<template>
  <div>
    <h3>Testing View</h3>
    <div>
      <div class="text-start h3">Groups</div>
      <pre class="text-start">{{ getMappedGroups }}</pre>
    </div>
  </div>
</template>

<script>
/* https://vuejs.org/guide/essentials/lifecycle.html#lifecycle-diagram */
import { mapGetters } from "vuex";
export default {
  name: "template",
  components: {},
  data() {
    return {};
  },
  props: {},
  computed: {
    ...mapGetters(["getCodes"]),
    ...mapGetters("achievements", [
      "getMyAchievementsList",
      "getGeneratedAchievementFeed"
    ]),
    ...mapGetters("groups", [
      "getGroups",
      "getMyGroup",
      "getMappedGroups",
      "getMyMappedGroup"
    ])
  },
  methods: {}
  /* lifecycle hooks */
};
</script>
